



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({ components: { Surface, Typography } })
export default class Table extends Vue {
  @Prop({ default: false }) readonly empty?: boolean;
  @Prop({ default: false }) readonly loading?: boolean;
  @Prop({ default: false }) readonly responsive?: boolean;

  @Watch('loading')
  setLoading() {
    if (this.loading) {
      this.$showLoaderWithLocker();
    } else {
      this.$hideLoader();
    }
  }

  mounted() {
    this.setLoading();
  }
}
